import { render } from "./PanelPublicistaComparativa.vue?vue&type=template&id=28bd7413&scoped=true"
import script from "./PanelPublicistaComparativa.vue?vue&type=script&lang=js"
export * from "./PanelPublicistaComparativa.vue?vue&type=script&lang=js"

import "./PanelPublicistaComparativa.vue?vue&type=style&index=0&id=28bd7413&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28bd7413"]])

export default __exports__